module.exports = __webpack_public_path__ + "img/2.041a0f21.png";